import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class UserSessionService {
  public loggedIn = new BehaviorSubject<boolean>(false);
  public username = new BehaviorSubject<string>('');


  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  
}